/* -----------------Globals--------------- */
import { useSafeAreaInsets } from "react-native-safe-area-context";

import { isWeb } from "@memorang/helpers/src/common";
/* -----------------UI--------------- */
import { Button, List, Surface } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import useBreakpoints from "../../useBreakpoints";
import { useDevice } from "../../useDevice";
import Box from "../Box";
import { CustomListSubheader } from "../CustomListSubheader";

type Props = {
	cta: string;
	handleAction: (dismiss?: boolean) => void;
	disabled: boolean;
	subheader: string;
	title: string;
};
export const StickyActionFooter = ({
	cta,
	handleAction,
	disabled,
	subheader,
	title,
}: Props) => {
	const insets = useSafeAreaInsets();
	const theme = useAppTheme();
	const { isMobile } = useDevice();
	const { xsDown } = useBreakpoints();
	return (
		<Surface
			style={{
				position: "absolute",
				bottom: 0,
				left: 0,
				right: 0,
				gap: 16,
				paddingTop: 8,
				paddingBottom: insets.bottom + 16,
			}}
		>
			{xsDown && (
				<>
					<CustomListSubheader>{subheader}</CustomListSubheader>
					<List.Item
						title={title}
						style={{
							backgroundColor: theme.colors.surfaceDisabled,
						}}
						left={(p) => {
							return <List.Icon {...p} icon={"check"} />;
						}}
					/>
				</>
			)}
			<Box
				flexDirection="row"
				width="100%"
				justifyContent="flex-end"
				paddingHorizontal={16}
				gap={8}
			>
				{!isMobile && (
					<Button disabled={disabled} onPress={() => handleAction(true)}>
						{"Dismiss"}
					</Button>
				)}
				<Button
					style={{
						width: isWeb ? "auto" : "100%",
					}}
					disabled={disabled}
					mode="contained"
					onPress={() => handleAction(false)}
				>
					{cta}
				</Button>
			</Box>
		</Surface>
	);
};
